import Observable from 'zen-observable';

import {InMemoryCache, Cache} from '../cache';
import {Client} from './types';
import {Type, Node, OutputNode} from '../model/types';
import {Hasher, MemoizedHasher} from '../hash';

export class CachedClient implements Client {
  private readonly cache: Cache;
  private readonly hasher: Hasher;
  public constructor(private readonly client: Client) {
    this.hasher = new MemoizedHasher();
    this.cache = new InMemoryCache({
      maxElements: 10,
      keyFn: this.hasher.typedNodeId,
    });
  }
  subscribe<T extends Type>(node: Node<T>): Observable<any> {
    return this.client.subscribe(node);
  }

  async query<T extends Type>(node: Node<T>): Promise<any> {
    if (await this.cache.has(node)) {
      // console.log(`Cache hit! ${(node as OutputNode).fromOp.name}`);
      return this.cache.get(node);
    }

    const result = await this.client.query(node);
    await this.cache.set(node, result, 30);
    return result;
  }

  loadingObservable(): Observable<boolean> {
    return this.client.loadingObservable();
  }
}
